// Available projects/data sources that match backend configuration
export const PROJECTS = [
  {
    id: 'dcli_benefits',
    name: 'DCLI Benefits',
    description: 'Employee benefits and HR policies'
  },
  {
    id: 'finance_bot',
    name: 'Finance Bot',
    description: 'Financial data and analytics'
  }
  // Add more projects as they become available in backend
];

export const DEFAULT_PROJECT = 'dcli_benefits';
